import { useSyncExternalStore } from 'react';

import {
  isConceptGroupExportInFlight,
  subscribeToConceptGroupExportsInFlight,
} from '../lib/api/downloadConceptGroupsWorkbook';

/**
 * Whether an export is in flight for this project — still true after the modal
 * closes, since the fetch keeps running. Drives the pill's disabled state.
 */
export const useConceptGroupExportInFlight = (projectId: string): boolean =>
  useSyncExternalStore(subscribeToConceptGroupExportsInFlight, () =>
    isConceptGroupExportInFlight(projectId)
  );
